import React from 'react'
import {useNavigation} from 'react-navi'
import {useAppState} from '../../../state'
import {Message} from '../../../state/messages/state'
import {A11yListContainer, ListItem} from '../../../Components/Atoms/Lists'
import TripletComponent from '../../../Components/Molecules/ListComponents/TripletComponent'
import {getHumanizedDateString} from '../../../Components/Atoms/Utils'

interface MessageSettingsListProps {
  isSystemMessagesView?: boolean
}

const MessageSettingsList = ({isSystemMessagesView}: MessageSettingsListProps) => {
  const {state} = useAppState()
  let messages = []
  if (isSystemMessagesView) {
    messages = state.v1.messages.systemMessages
  } else {
    messages = state.v1.messages.messages
  }

  const navigationLink = isSystemMessagesView ? '/admin/messages/' : '/settings/messages/'

  return (
    <A11yListContainer>
      {messages.length
        ? messages.map(message => {
            return <MessageListItem key={message.id} message={message} navigationLink={navigationLink} />
          })
        : null}
    </A11yListContainer>
  )
}

interface MessageListItemProps {
  message: Message
  navigationLink: string
}

const MessageListItem = ({message, navigationLink}: MessageListItemProps) => {
  const nav = useNavigation()
  const {state} = useAppState()
  const locale = state.site?.locale || 'fi-FI'

  return (
    <ListItem
      onClick={() => {
        nav.navigate(`${navigationLink}${message.id}`)
      }}
    >
      <TripletComponent
        title={message.heading}
        captions={[
          getHumanizedDateString(new Date(message.startDate), locale),
          getHumanizedDateString(new Date(message.endDate), locale)
        ]}
      />
    </ListItem>
  )
}

export default MessageSettingsList
